import { Table } from "react-bootstrap";

/**
 * @param {Object} props
 * @param {number} [props.rows=5] - Number of skeleton rows to display
 */
const QuestSelectorSkeleton = ({ rows = 5 }) => {
  return (
    <div className="custom-table-container">
      <div className="custom-table-wrapper select-student-table-scroll">
        <Table hover className="custom-table">
          <thead className="custom-table-head">
            <tr>
              <th>
                <div
                  className="skeleton-box"
                  style={{
                    height: "20px",
                    width: "60%",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                ></div>
              </th>
              <th>
                <div
                  className="skeleton-box"
                  style={{
                    height: "20px",
                    width: "80%",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                ></div>
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <tr key={rowIndex}>
                <td>
                  <div
                    className="skeleton-box"
                    style={{
                      height: "16px",
                      width: "24px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "3px",
                      animation: "pulse 1.5s ease-in-out infinite",
                      animationDelay: `${rowIndex * 0.1}s`,
                    }}
                  ></div>
                </td>

                <td>
                  <div
                    className="skeleton-box"
                    style={{
                      height: "16px",
                      width: "90%",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "4px",
                      animation: "pulse 1.5s ease-in-out infinite",
                      animationDelay: `${rowIndex * 0.1}s`,
                    }}
                  ></div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default QuestSelectorSkeleton;
